import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={15}
    height={15}
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={0.5} y={1} width={14} height={14} rx={2.5} stroke="white" />
    <path
      d="M3.66633 7.03492L2.25 8.56586L6.39131 12.5L12.8864 4.03823L11.2519 2.75L6.15089 9.39533L3.66633 7.03492Z"
      fill="white"
    />
  </svg>
);
export default SVGComponent;
